/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Revealhiddenachievementaria3Inputs */

const id_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan teks pencapaian tersembunyi`)
};

const ms_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedahkan teks pencapaian tersembunyi`)
};

const da_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis skjult achievement-tekst`)
};

const de_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versteckten Errungenschaftstext anzeigen`)
};

const en_us2_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reveal hidden achievement text`)
};

const es_es2_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar texto de logros ocultos`)
};

const es_mx2_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar texto de logros ocultos`)
};

const fil_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibunyag ang nakatagong teksto ng achievement`)
};

const fr_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révéler le texte du succès caché`)
};

const it_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivela testo risultato nascosto`)
};

const hu_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejtett teljesítmény szöveg felfedése`)
};

const nl_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verborgen prestatietekst onthullen`)
};

const no_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avslør skjult prestasjonstekst`)
};

const pl_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż ukryty tekst osiągnięcia`)
};

const pt_br2_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar texto de conquista oculto`)
};

const pt_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar texto de conquista oculta`)
};

const ro_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezvăluie textul realizării ascunse`)
};

const fi_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paljasta piilotetun saavutuksen teksti`)
};

const sv_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa dold prestationstext`)
};

const vi_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện nội dung thành tích ẩn`)
};

const tr_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizli başarım metnini göster`)
};

const cs_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit text skrytého úspěchu`)
};

const bg_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разкриване на скрит текст за постижение`)
};

const ru_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать текст скрытого достижения`)
};

const uk_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показати прихований текст досягнення`)
};

const ar_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكشف عن نص الإنجاز المخفي`)
};

const hi_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छिपी हुई उपलब्धि टेक्स्ट दिखाएँ`)
};

const th_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดเผยข้อความความสำเร็จที่ซ่อนอยู่`)
};

const ja_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隠された実績テキストを表示`)
};

const zh_cn2_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示隐藏成就文本`)
};

const zh_hant1_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顯示隱藏成就文字`)
};

const ko_sandboxes_revealhiddenachievementaria3 = /** @type {(inputs: Sandboxes_Revealhiddenachievementaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숨겨진 도전 과제 텍스트 표시`)
};

/**
* | output |
* | --- |
* | "Reveal hidden achievement text" |
*
* @param {Sandboxes_Revealhiddenachievementaria3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_revealhiddenachievementaria3 = /** @type {((inputs?: Sandboxes_Revealhiddenachievementaria3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Revealhiddenachievementaria3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "ms") return ms_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "da") return da_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "de") return de_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "fil") return fil_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "fr") return fr_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "it") return it_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "hu") return hu_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "nl") return nl_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "no") return no_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "pl") return pl_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "pt") return pt_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "ro") return ro_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "fi") return fi_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "sv") return sv_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "vi") return vi_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "tr") return tr_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "cs") return cs_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "bg") return bg_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "ru") return ru_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "uk") return uk_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "ar") return ar_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "hi") return hi_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "th") return th_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "ja") return ja_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_revealhiddenachievementaria3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_revealhiddenachievementaria3(inputs)
	return ko_sandboxes_revealhiddenachievementaria3(inputs)
});
export { sandboxes_revealhiddenachievementaria3 as "sandboxes.revealHiddenAchievementAria" }